import { RBAC_KEY } from "src/consts/rbac";

export const MONEY_TRANSFER_RBAC = [
  RBAC_KEY.MONEY_TRANSFER_NEW_TRX,
  RBAC_KEY.MONEY_TRANSFER_HISTORY,
  RBAC_KEY.MONEY_TRANSFER_REPORT,
  RBAC_KEY.APPROVAL,
  RBAC_KEY.BENEFICIARY_LIST
];

export const INTERNATIONAL_TRANSFER_RBAC = [
  RBAC_KEY.INTERNATIONAL_TRANSFER_NEW_TRX,
  RBAC_KEY.INTERNATIONAL_TRANSFER_HISTORY,
  RBAC_KEY.INTERNATIONAL_TRANSFER_REPORT
];

export const ACCEPT_PAYMENT_RBAC = [
  RBAC_KEY.ACCEPT_PAYMENT_NEW,
  RBAC_KEY.ACCEPT_PAYMENT_CONFIGURATION,
  RBAC_KEY.ACCEPT_PAYMENT_HISTORY,
  RBAC_KEY.ACCEPT_PAYMENT_REFUND_HISTORY,
  RBAC_KEY.ACCEPT_PAYMENT_REPORT,
  RBAC_KEY.ACCEPT_PAYMENT_SETTLEMENT_REPORT
];

export const DEPOSIT_RBAC = [RBAC_KEY.DEPOSIT, RBAC_KEY.DEPOSIT_HISTORY, RBAC_KEY.DEPOSIT_STATEMENT];

export const REFUND_RBAC = [RBAC_KEY.REFUND_CREATE, RBAC_KEY.REFUND_HISTORY];

export const SETTINGS_RBAC = [
  RBAC_KEY.SETTINGS_PROFILE,
  RBAC_KEY.SETTINGS_NOTIFICATION,
  RBAC_KEY.SETTINGS_TRANSACTION,
  RBAC_KEY.SETTINGS_DEPOSIT,
  RBAC_KEY.SETTINGS_TFA_NEW,
  RBAC_KEY.SETTINGS_ACTIVITY_LOG
];

export const DEVELOPER_RBAC = [RBAC_KEY.SETTINGS_API];

export const SANDBOX_MT_RBAC = [RBAC_KEY.SANDBOX_MT_HISTORY, RBAC_KEY.SANDBOX_MT_NEW_TRX];

export const SANDBOX_IT_RBAC = [RBAC_KEY.SANDBOX_IT_HISTORY];

export const SANDBOX_AP_RBAC = [RBAC_KEY.SANDBOX_ACCEPT_PAYMENT, RBAC_KEY.SANDBOX_ACCEPT_PAYMENT_HISTORY];

export const SANDBOX_DEVELOPER_RBAC = [
  RBAC_KEY.SANDBOX_SNAP_CREDENTIAL,
  RBAC_KEY.SANDBOX_ACCOUNT_INQUIRY_HISTORY,
  RBAC_KEY.SANDBOX_VERIFICATION_HISTORY
];
